/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineIdMaterialsTree200,
  GetApiV1ClassroomdisciplineIdMaterialsTree401,
  GetApiV1ClassroomdisciplineIdMaterialsTree404,
  GetApiV1ClassroomdisciplineIdMaterialsTreePathParams,
  GetApiV1ClassroomdisciplineIdMaterialsTreeQueryParams,
  GetApiV1ClassroomdisciplineIdMaterialsTreeQueryResponse,
} from "../../types/classPlanningMaterialController/GetApiV1ClassroomdisciplineIdMaterialsTree.ts";
import { materialTreeNodeViewModelSchema } from "../materialTreeNodeViewModelSchema.ts";

export const getApiV1ClassroomdisciplineIdMaterialsTreePathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1ClassroomdisciplineIdMaterialsTreePathParams>;

export const getApiV1ClassroomdisciplineIdMaterialsTreeQueryParamsSchema = z
  .object({
    culture: z.optional(z.string()),
  })
  .optional() as unknown as ToZod<GetApiV1ClassroomdisciplineIdMaterialsTreeQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineIdMaterialsTree200Schema = z.lazy(
  () => materialTreeNodeViewModelSchema,
) as unknown as ToZod<GetApiV1ClassroomdisciplineIdMaterialsTree200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineIdMaterialsTree401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdMaterialsTree401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ClassroomdisciplineIdMaterialsTree404Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdMaterialsTree404>;

export const getApiV1ClassroomdisciplineIdMaterialsTreeQueryResponseSchema =
  z.lazy(
    () => getApiV1ClassroomdisciplineIdMaterialsTree200Schema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineIdMaterialsTreeQueryResponse>;
